// ✅ CustomerModal.jsx με υποστήριξη για Add & Edit

import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const CustomerModal = ({
  isOpen,
  onClose,
  onSave,
  onUpdate,
  onDelete,
  existingCustomers,
  mode = 'add',
  customer = null
}) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [notes, setNotes] = useState('');
  const [wantsSms, setWantsSms] = useState(false);
  const [wantsEmail, setWantsEmail] = useState(false);
  const [phoneError, setPhoneError] = useState('');

  const handleDelete = () => {
  if (!customer?.id) return;
  if (window.confirm('Θέλεις σίγουρα να διαγράψεις τον πελάτη;')) {
    onDelete(customer.id);
    onClose();
  }
};

  useEffect(() => {
 
    if (mode === 'edit' && customer) {
      setName(customer.name || '');
      setPhone(customer.phone || '');
      setEmail(customer.email || '');
      setNotes(customer.notes || '');
      setWantsSms(customer.wants_sms === 1 || customer.wants_sms === '1');
      setWantsEmail(customer.wants_email === 1 || customer.wants_email === '1');
         console.log('🟡 customer.wants_sms:', customer.wants_sms, typeof customer.wants_sms);
    console.log('🟡 customer.wants_email:', customer.wants_email, typeof customer.wants_email);

    } else {
      setName('');
      setPhone('');
      setEmail('');
      setNotes('');
      setWantsSms(false);
      setWantsEmail(false);
    }
    setPhoneError('');
  }, [isOpen, mode, customer]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) return;

    if (!/^69\d{8}$/.test(phone)) {
      const msg = 'Το κινητό πρέπει να ξεκινά με 69 και να έχει 10 ψηφία.';
      setPhoneError(msg);
      toast.error(msg);
      return;
    }
    setPhoneError('');

    const cleanedPhone = phone.trim();
    const cleanedEmail = email.trim().toLowerCase();

    // Έλεγχος για διπλό κινητό σε άλλον πελάτη (όχι στον ίδιο)
    const existingPhone = existingCustomers.find(
      (c) => c.phone.trim() === cleanedPhone && c.id !== (customer?.id || null)
    );
    if (existingPhone) {
      const msg = `Ο αριθμός ανήκει ήδη στον πελάτη: ${existingPhone.name}`;
      setPhoneError(msg);
      toast.error(msg);
      return;
    }

    if (cleanedEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanedEmail)) {
      toast.error('Το email δεν είναι έγκυρο.');
      return;
    }

    const existingEmail = existingCustomers.find(
      (c) =>
        c.email &&
        c.email.trim().toLowerCase() === cleanedEmail &&
        c.id !== (customer?.id || null)
    );
    if (existingEmail) {
      toast.error(`Το email ανήκει ήδη στον πελάτη: ${existingEmail.name}`);
      return;
    }

    const payload = {
      id: customer?.id,
      name,
      phone: cleanedPhone,
      email: cleanedEmail,
      notes,
      wants_sms: wantsSms ? 1 : 0,
      wants_email: wantsEmail ? 1 : 0,
    };

    if (mode === 'edit') {
      onUpdate(payload);
    } else {
      onSave(payload);
    }

    onClose();
  };

  if (!isOpen) return null;

  return (
    
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">
          {mode === 'edit' ? 'Επεξεργασία Πελάτη' : 'Νέος Πελάτης'}
        </h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Ονοματεπώνυμο"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={10}
            placeholder="Τηλέφωνο"
            value={phone}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
            className={`w-full border p-2 rounded ${phoneError ? 'border-red-500' : ''}`}
            required
          />
          {phoneError && <p className="text-red-500 text-sm mt-1">{phoneError}</p>}

          <input
            type="email"
            placeholder="Email (προαιρετικό)"
            value={email}
            onChange={(e) => setEmail(e.target.value.trimStart())}
            className="w-full border p-2 rounded"
          />
          <textarea
            placeholder="Σημειώσεις"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="w-full border p-2 rounded h-24 resize-none"
          ></textarea>

          <div className="flex items-center justify-between text-sm">
            <label className="flex items-center gap-2 cursor-pointer">
              <span>Αποστολή SMS</span>
              <div
                className={`w-10 h-5 flex items-center bg-gray-300 rounded-full p-1 duration-300 ease-in-out ${wantsSms ? 'bg-green-500' : ''}`}
                onClick={() => setWantsSms(!wantsSms)}
              >
                <div
                  className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${wantsSms ? 'translate-x-5' : ''}`}
                />
              </div>
            </label>

<label className="flex items-center gap-2 cursor-pointer">
  <span>Αποστολή Email</span>
  <div
    className={`w-10 h-5 flex items-center bg-gray-300 rounded-full p-1 duration-300 ease-in-out ${wantsEmail ? 'bg-sky-500' : ''}`}
    onClick={() => {
      if (!wantsEmail && !email.trim()) {
        toast.error('Παρακαλώ εισήγαγε email πριν ενεργοποιήσεις την αποστολή.');
        return;
      }
      setWantsEmail(!wantsEmail);
    }}
  >
    <div
      className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${wantsEmail ? 'translate-x-5' : ''}`}
    />
  </div>
</label>

          </div>

<div className="flex justify-between items-center pt-4">
  {mode === 'edit' && (
    <button
      type="button"
      onClick={handleDelete}
      className="px-4 py-1.5 text-sm text-white bg-red-500 hover:bg-red-600 rounded"
    >
      🗑️ Διαγραφή
    </button>
  )}

  <div className="flex gap-2">
    <button
      type="button"
      onClick={onClose}
      className="px-4 py-1.5 text-sm bg-gray-200 hover:bg-gray-300 rounded"
    >
      Άκυρο
    </button>
    <button
      type="submit"
      className="px-4 py-1.5 text-sm text-white bg-indigo-600 hover:bg-indigo-700 rounded"
    >
      {mode === 'edit' ? 'Ενημέρωση' : 'Αποθήκευση'}
    </button>
  </div>
</div>

        </form>
      </div>
    </div>
  );
};

export default CustomerModal;
